import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0a356b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "report-print"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-print__content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "report-print__content-title" }, "Печать отчёта"),
  /*#__PURE__*/_createElementVNode("p", { class: "report-print__content-info" }, " Отчёт откроется в новой вкладке, после чего его можно будет распечатать ")
], -1))
const _hoisted_3 = { class: "report-print__footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Печать ")

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  urlPart: String,
},
  setup(__props) {

const props = __props



const loading = ref(false)
const route = useRoute()
const reportId = computed(() => Number(route.params.reportId))

const pdfDownloadLink = computed(() => {
  let domain = window.origin

  if (process.env.NODE_ENV === 'production') {
    domain = process.env.VUE_APP_BASE_URI
  }

  return `${domain}/api/web/admin/${props.urlPart}/download-from-service/${reportId.value}`
})

const openForPrint = async function () {
  loading.value = true
  const response = await fetch(pdfDownloadLink.value)

  const blob = await response.blob()
  const pdfBlob = new Blob([blob], { type: 'application/pdf' })
  const blobUrl = URL.createObjectURL(pdfBlob)

  window.open(blobUrl, '_blank')

  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(reportId))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            class: "print-report",
            round: "",
            type: "primary",
            loading: loading.value,
            onClick: openForPrint
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})